import React from "react";
import SyncLoader from "react-spinners/SyncLoader";

interface LoaderProps {
  color?: string;
  loading?: boolean;
  margin?: number;
  size?: number;
  speedMultiplier?: number;
}

const Loader: React.FC<LoaderProps> = ({
  color = "#abacb2",
  loading = true,
  margin = 2,
  size = 15,
  speedMultiplier = 1, // Changed from 0 to 1 (0 would make it instant)
}) => {
  if (!loading) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.7)", // White with 70% opacity
        backdropFilter: "blur(2px)", // Optional: slight blur effect
      }}
    >
      <SyncLoader
        color={color}
        loading={loading}
        margin={margin}
        size={size}
        speedMultiplier={speedMultiplier}
      />
    </div>
  );
};

export default Loader;
